/**
 * @generated SignedSource<<2d18f79dbd297d038facb4ff10284a1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetSlackUserInput = {
  personId?: string | null;
  slackId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type SetSlackUserMutation$variables = {
  input: SetSlackUserInput;
};
export type SetSlackUserMutation$data = {
  readonly setSlackUser: {
    readonly viewer: {
      readonly slackId: string | null;
    } | null;
    readonly person: {
      readonly slackId: string | null;
    } | null;
  } | null;
};
export type SetSlackUserMutation = {
  variables: SetSlackUserMutation$variables;
  response: SetSlackUserMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackId",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetSlackUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetSlackUserPayload",
        "kind": "LinkedField",
        "name": "setSlackUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetSlackUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetSlackUserPayload",
        "kind": "LinkedField",
        "name": "setSlackUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa053707b1ae6f7a6bd19453ef5c8b21",
    "id": null,
    "metadata": {},
    "name": "SetSlackUserMutation",
    "operationKind": "mutation",
    "text": "mutation SetSlackUserMutation(\n  $input: SetSlackUserInput!\n) {\n  setSlackUser(input: $input) {\n    viewer {\n      slackId\n      id\n    }\n    person {\n      slackId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3503234264c18dbea5c79f5183f8874e";

export default node;
